import { FormattedMessage } from 'react-intl';
import { Hyperlink } from 'components/ui/atoms/link';
import { ViewOrderDetailsHyperlinkProps } from './types';

export const ViewOrderDetailsHyperlink = ({
  orderNumber,
}: ViewOrderDetailsHyperlinkProps) => (
  <Hyperlink
    destination={`${
      process.env.NEXT_PUBLIC_EDX_COMMERCE_COORDINATOR_BASE_URL! +
      process.env.NEXT_PUBLIC_EDX_CC_ORDER_RECEIPT_PATH!
    }?order_number=${orderNumber}`}
    target="_blank"
    className="tw-text-info-500"
  >
    <FormattedMessage
      id="payment.order.history.cell.view.receipt"
      defaultMessage="View Receipt"
      description="Link to an order receipt"
    />
  </Hyperlink>
);
